<template>
    <div class="brand">
        <div class="title">最佳活动</div>
        <div class="brandBox clear">
            <div class="brandItem clear" v-for="item in activityList" :key="item.id">
                <img class="fl" :src="item.brandIco" alt="">
                <span class="fl">{{item.name}}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activityList: []
        }
    },
    methods: {
        getData(data) {
            this.activityList = data
        }
    },
}
</script>

<style lang="scss" scoped>
.title{
    margin-top: 24px;
    color: #fff;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 16px;
}
.brandBox{
    padding: 24px 0;
    overflow-y: auto;
    height: 424px;
    background-color: #292941;
    border-radius: 12px;
    padding: 16px;
    box-sizing: border-box;
    color: #fff;
    .brandItem{
        height: 50px;
        margin-bottom: 16px;
        font-size: 14px;
        margin-bottom: 16px;
        line-height: 50px;
        img{
            width: 50px;
            height: 50px;
            margin-right: 12px;
            display: block;
        }
    }
}
</style>
